/**
 * Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */
import type { Component } from 'vue'

import type { ContentBlock } from '@/nonfree/ai/control-plane/api/conversations'

import AiBlockAnswer from './AiBlockAnswer.vue'
import AiBlockAside from './AiBlockAside.vue'
import AiBlockPrompt from './AiBlockPrompt.vue'
import AiBlockTurnEnd from './AiBlockTurnEnd.vue'

export function blockComponent(block: ContentBlock): Component {
  switch (block.type) {
    case 'prompt':
      return AiBlockPrompt
    case 'text':
      return AiBlockAnswer
    case 'thinking':
    case 'tool_use':
    case 'tool_result':
      return AiBlockAside
    case 'completed':
    case 'failed':
    case 'cancelled':
      return AiBlockTurnEnd
  }
}
